import { render, staticRenderFns } from "./confirm.vue?vue&type=template&id=616a2327&scoped=true&"
import script from "./confirm.vue?vue&type=script&lang=js&"
export * from "./confirm.vue?vue&type=script&lang=js&"
import style0 from "./confirm.vue?vue&type=style&index=0&id=616a2327&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616a2327",
  null
  
)

component.options.__file = "confirm.vue"
export default component.exports